export default __webpack_public_path__ + "static/media/640_dummy2016-tattoo01-mobile-de.71ee421c.png";